import {
  postDataNoTeamSwap,
  postDataTeamSwap,
} from "@aura-frontend/omnibus-az-client";

import { TeamSide } from "../constants/teams";

/**
 * Set Home Team (the mobile app's "Who is home team?"): picking the away team
 * swaps the sides of the game active on the machine (POST /data/team-swap);
 * keeping the home team confirms them as scheduled (POST /data/no-team-swap).
 * Either marks the game's teams as validated. Omnibus passes the swap on to
 * the game service, which sends the swapped teams over the stream.
 */
export const setHomeTeam = async (machineUuid: string, homeSide: TeamSide) => {
  const body = { machineUuid };
  if (homeSide === "away") {
    await postDataTeamSwap({ body, throwOnError: true });
  } else {
    await postDataNoTeamSwap({ body, throwOnError: true });
  }
};
